import React from "react";
import { Form, InputNumber } from "antd";

export function NumberInput(props) {
  const onFocus = (e) => {
    if (props.isAutoSelect) {
      return e.target.select();
    }
  };
  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      className={props.className}
      style={props.style}
      rules={[
        {
          required: props.required,
          message: props.errorMessage,
        },
      ]}
    >
      <InputNumber
        onChange={props.onChange}
        defaultValue={props.defaultValue}
        placeholder={props.placeholder}
        value={props.value}
        min={props.min}
        max={props.max}
        prefix={props.prefix}
        status={props.status}
        disabled={props.disabled}
        addonBefore={props.addonBefore}
        addonAfter={props.addonAfter}
        onFocus={onFocus}
        controls={props.controls}
        precision={props.precision}
        readOnly={props.readOnly}
        formatter={props.formatter}
        step={props.step}
        type="number"
        onStep={props.onStep}
        onBlur={props.onBlur}
        style={{ width: "100%" }}
      />
    </Form.Item>
  );
}
